import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import formatVehicleTitle from '../utils/formatVehicleTitle';

const VehicleTitle = ({ vehicle, as: Tag = 'p' }) => {
	const prefs = usePrefs();
	return (
		<Tag className="vehicle-card__title font-weight-bold mb-0">
			{formatVehicleTitle(vehicle, prefs.titlePattern)}
		</Tag>
	);
};

VehicleTitle.propTypes = {
	vehicle: PropTypes.shape({
		year: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
			.isRequired,
		make: PropTypes.string.isRequired,
		model: PropTypes.string.isRequired
	}).isRequired,
	as: PropTypes.string
};

export default VehicleTitle;
